import { useEffect, useRef, useState } from "react";
import { CaretDown, Check } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

// In-scope dropdown (no portal) so the Promotion Center theme tokens always apply.
export function PromoSelect({ value, onChange, options, placeholder = "Seleziona…", testId, className, disabled = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const selected = options.find((o) => o.value === value);

  if (disabled) {
    return (
      <div className={cn("relative", className)}>
        <div
          className="flex h-10 w-full cursor-not-allowed items-center justify-between gap-2 rounded-md border border-dashed border-input bg-muted/40 px-3 text-sm text-muted-foreground opacity-70"
          data-testid={testId}
          aria-disabled="true"
        >
          <span className="truncate">{placeholder}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={cn("relative", className)} ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={cn(
          "flex h-10 w-full items-center justify-between gap-2 rounded-md border border-input bg-card px-3 text-sm transition-colors hover:bg-accent/40",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background",
        )}
        data-testid={testId}
      >
        <span className={cn("truncate", !selected && "text-muted-foreground")}>
          {selected ? selected.label : placeholder}
        </span>
        <CaretDown size={14} className={cn("shrink-0 text-muted-foreground transition-transform", open && "rotate-180")} />
      </button>
      {open && (
        <div
          className="absolute z-50 mt-1.5 max-h-64 w-full overflow-y-auto rounded-md border border-border bg-popover p-1 shadow-lg"
          data-testid={testId ? `${testId}-menu` : undefined}
        >
          {options.map((o) => (
            <button
              key={o.value ?? "__none"}
              type="button"
              onClick={() => { onChange(o.value); setOpen(false); }}
              className={cn(
                "flex w-full items-center justify-between gap-2 rounded-sm px-2.5 py-2 text-left text-sm transition-colors hover:bg-accent",
                o.value === value && "text-brand",
              )}
              data-testid={testId ? `${testId}-opt-${o.value ?? "none"}` : undefined}
            >
              <span className="truncate">{o.label}</span>
              {o.value === value && <Check size={14} weight="bold" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
